export const ANALYTICS_EVENTS = {
  PAGE_VIEWED: "Page Viewed",
  WEB_CAMPAIGN_ATTRIBUTION_CAPTURED: "Web Campaign Attribution Captured",
  ONBOARDING_STARTED: "Onboarding Started",
  ONBOARDING_STEP_VIEWED: "Onboarding Step Viewed",
  ONBOARDING_STEP_COMPLETED: "Onboarding Step Completed",
  CAREGIVER_INVITE_ADDED: "Caregiver Invite Added",
  AUTH_PROMPT_OPENED: "Auth Prompt Opened",
  KAKAO_LOGIN_STARTED: "Kakao Login Started",
  KAKAO_LOGIN_FAILED: "Kakao Login Failed",
  LOGIN_SUCCEEDED: "Login Succeeded",
  PWA_INSTALL_SURFACE_VIEWED: "PWA Install Surface Viewed",
  PWA_INSTALL_CTA_CLICKED: "PWA Install CTA Clicked",
  PWA_INSTALL_GUIDE_OPENED: "PWA Install Guide Opened",
  PWA_INSTALL_PROMPT_REQUESTED: "PWA Install Prompt Requested",
  PWA_INSTALL_PROMPT_ACCEPTED: "PWA Install Prompt Accepted",
  PWA_INSTALL_PROMPT_DISMISSED: "PWA Install Prompt Dismissed",
  NATIVE_APP_PROMOTION_VIEWED: "Native App Promotion Viewed",
  NATIVE_APP_LAUNCH_ATTEMPTED: "Native App Launch Attempted",
  NATIVE_APP_LAUNCH_LEFT_PAGE_OBSERVED: "Native App Launch Left Page Observed",
  NATIVE_APP_LAUNCH_FALLBACK_SHOWN: "Native App Launch Fallback Shown",
  NATIVE_APP_STORE_CLICKED: "Native App Store Clicked",
  NATIVE_APP_PROMOTION_DISMISSED: "Native App Promotion Dismissed",
  NATIVE_APP_PROMOTION_RETRY: "Native App Promotion Retry",
  NATIVE_APP_STORE_LINK_COPIED: "Native App Store Link Copied",
  REGISTRATION_COMPLETED: "Registration Completed",
  SIGNUP_COMPLETED: "Signup Completed",
  GROUP_CREATED: "Group Created",
  ROUTINE_COMPOSER_OPENED: "Routine Composer Opened",
  ROUTINE_CREATE_STARTED: "Routine Create Started",
  ROUTINE_CREATED: "Routine Created",
  FIRST_ROUTINE_CREATED: "First Routine Created",
  ROUTINE_COMPLETED: "Routine Completed",
  SUBSCRIPTION_VIEWED: "Subscription Viewed",
  SUBSCRIPTION_PLAN_SELECTED: "Subscription Plan Selected",
  SUBSCRIPTION_PURCHASE_STARTED: "Subscription Purchase Started",
  SUBSCRIPTION_PURCHASE_COMPLETED: "Subscription Purchase Completed",
  SUBSCRIPTION_PURCHASE_FAILED: "Subscription Purchase Failed",
  TRIAL_PAYWALL_VIEWED: "Trial Paywall Viewed",
  BILLING_SETUP_VIEWED: "Billing Setup Viewed",
  BILLING_SETUP_STARTED: "Billing Setup Started",
  BILLING_SETUP_COMPLETED: "Billing Setup Completed",
  TRIAL_UPGRADE_STARTED: "Trial Upgrade Started",
  TRIAL_UPGRADE_COMPLETED: "Trial Upgrade Completed",
} as const;

export type AnalyticsEventName = typeof ANALYTICS_EVENTS[keyof typeof ANALYTICS_EVENTS];

export function resolveRouteGroup(path: string) {
  if (path.startsWith("/onboarding")) {
    return "onboarding";
  }

  if (path.startsWith("/app/billing")) {
    return "billing";
  }

  if (path.startsWith("/app/settings")) {
    return "settings";
  }

  if (path.startsWith("/app/notifications")) {
    return "notifications";
  }

  if (path.startsWith("/app/guide")) {
    return "guide";
  }

  if (path.startsWith("/app")) {
    return "app";
  }

  if (path.startsWith("/pricing")) {
    return "pricing";
  }

  if (path.startsWith("/review")) {
    return "review";
  }

  if (path.startsWith("/terms")) {
    return "terms";
  }

  if (path.startsWith("/refund-policy")) {
    return "refund-policy";
  }

  return "landing";
}
